import { CartCoupon } from 'src/types/common';

type CalculateDiscountParams = {
  cartTotal: number;
  couponDetails: CartCoupon;
  isB2b: boolean;
};

export default function calculateDiscount({
  cartTotal,
  couponDetails,
  isB2b,
}: CalculateDiscountParams): number | null {
  if (isB2b) {
    return null;
  }

  const { is_strict, conditions, total_with_coupon } = couponDetails;

  if (conditions.length) {
    const allConditionsMet = is_strict
      ? conditions.every((condition) => condition.success)
      : conditions.some((condition) => condition.success);

    return allConditionsMet && typeof total_with_coupon === 'number'
      ? cartTotal - total_with_coupon
      : null;
  } else {
    return typeof total_with_coupon === 'number'
      ? cartTotal - total_with_coupon
      : null;
  }
}
